import classnames from 'classnames';
import type { FC, ReactNode } from 'react';
import { memo } from 'react';

import {
  badgeColors,
  badgeSizes,
  type BadgeSizesTypes,
  badgeVariants,
  type BadgeVariantTypes,
} from './badgeModifiers';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  classNames?: string;
  color?: string;
  size?: BadgeSizesTypes;
  variant?: BadgeVariantTypes;
  children: ReactNode;
}

const Badge: FC<BadgeProps> = ({
  classNames,
  children,
  color = 'default',
  size = 'default',
  variant = 'default',
}) => {
  return (
    <span
      className={classnames('badge', classNames, {
        [badgeColors[color]]: color,
        [badgeSizes[size]]: size,
        [badgeVariants[variant]]: variant,
      })}
    >
      {children}
    </span>
  );
};

export default memo(Badge);
